import { SyntheticEvent, useEffect, useRef, useState } from 'react'
import './TeacherStudentClassroom.scss';
import { Tab, Tabs, styled } from '@mui/material';
import images from '../../assets/images';
import MyLibrary from '../../components/MyLibrary/MyLibrary';
import Subjects from '../../components/Subjects/Subjects';
import { useLazyQuery, useMutation } from '@apollo/client';
import { IS_LIVE_SESSION_NOW } from '../LiveClass/api/LiveClassQuery';
import dayjs from 'dayjs';
import { useAppSelector } from '../../redux/app/hooks';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, STUDENT_ROLE, VIRTUAL } from '../../utils/constants';
import { UPDATE_ACTIVE_STATUS } from '../CommonChats/api/ChatsQuery';
import ToasterWithMessage from '../../components/toaster';
import axios, { AxiosResponse } from 'axios';
import { Advertisement, ScreenImages } from '../../components/AdminRightSideAd/AdminRightSideAd';
import { getScreenDimensions } from '../../utils/helper';
import { useDispatch } from 'react-redux';
import { setSelectedTabindex } from '../../redux/slices/authSlice';
import { setIndication } from '../../redux/slices/indication';
import MobileScreenHeader from '../../components/MobileScreenHeader/MobileScreenHeader';

// Custom styled Tab component
const CustomTab = styled(Tab)(({ theme }) => ({
    fontFamily: 'var(--font-inter)',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '14.52px',
    textTransform: 'capitalize',
    padding: '0 var(--padding-3xs)',
    flex: 1,
    maxWidth: '140px', // Need to remove while using all tabs
    display: 'flex',
    minHeight: '31px',
    // maxWidth: '140px',
    columnGap: '10px',
    borderRadius: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    '&.Mui-selected': {
      color: 'white',
      backgroundColor: '#0B74BB'
    },
    '&:not(.Mui-selected)': {
      color: 'black',
      backgroundColor: '#F0F3F5'
    },
  }));

  const StyledTabs = styled(Tabs)(({theme}) => ({
      '& .MuiTabs-indicator': { display: 'none' },
  }))
const TeacherStudentClassroom = () => {
    const  {redDotImage} = images;
    const role = useAppSelector((state) => state.auth.role);
    const schoolType = useAppSelector((state) => state.auth.schoolType);
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const tab = localStorage?.getItem('teacherStudentTabIndex');
    const [isLive,setIsLive] = useState<boolean>(false);
    const [activeTab,setActiveTab] = useState(tab ? parseInt(tab) : 0);
    const { error } = ToasterWithMessage();
    const [loader,setLoading] = useState<boolean>(false)
    const katonCms = process.env.REACT_APP_KATON_CMS_SITE;
    const [screenImages, setScreenImages] = useState<ScreenImages[]>([]);
    const [advertisements, setAdvertisement] = useState<string[]>([]);
    // const [isquizActive, setIsQuizActive] = useState<boolean>(false)
    const isquizActive = useAppSelector((state) => state.indication.indication.quiz)
    const isAssignmentActive = useAppSelector((state) => state.indication.indication.assignment)
    const isMylibaryActive = useAppSelector((state) => state.indication.indication.myLibary)
    const isChatActive = useAppSelector((state) => state.indication.indication.chat)
    const profile = useAppSelector((state) => state?.auth?.adminProfile);
    const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
    const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
    const selectedTabindex = useAppSelector((state) => state.auth.selectedTabindex);
    const dispatch = useDispatch();
    const liveSessionInitializedRef = useRef(false);
    
    const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        dispatch(setSelectedTabindex({selectedTabindex: String(newValue)}));
        localStorage.setItem('teacherStudentTabIndex', String(newValue));
    }

      // to find now any live session in classroom
    const [ isLiveSessionNow ] = useLazyQuery(IS_LIVE_SESSION_NOW, {
      fetchPolicy: FETCH_POLICY,
      onCompleted: (data) => {
        setIsLive(data?.isLiveSessionOngoing);
        dispatch(setIndication({ 
              live: data?.isLiveSessionOngoing, 
        }));
      },
      onError: (err) => {
        // error("Something went wrong!")
      }
    });

  const [updateChatActiveStatus] = useMutation(UPDATE_ACTIVE_STATUS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
    },
    onError: (err) => {
      error(err?.message);
    }
  });

   // Update chat active status on mount and when activeTab changes
   useEffect(() => {
      const isChatTab = activeTab === 3;
        updateChatActiveStatus({
          variables: {
            chatActive: isChatTab
          }
        });
   }, [activeTab]);

   // Handle advertisement changes separately
   useEffect(() => {
      const handleAdvertisement = () => {
        const lowercaseScreen = (screen: string) => screen.toLowerCase();
        let adIs: ScreenImages | undefined;
          switch (activeTab) {
                case 0:
                    adIs = screenImages.find(ad => lowercaseScreen(ad.screen) === (schoolType === VIRTUAL ? "liveclass" : "mylibrary"));
                    break;
                case 1:
                    adIs = screenImages.find(ad => lowercaseScreen(ad.screen) === (schoolType === VIRTUAL ? "mylibrary" : "quiz"));
                    break;
                case 2:
                    adIs = screenImages.find(ad => lowercaseScreen(ad.screen) === "assignments");
                    break;
                case 3:
                    adIs = screenImages.find(ad => lowercaseScreen(ad.screen) === "chats");
                    break;
                case 4:
                    adIs = screenImages.find(ad => lowercaseScreen(ad.screen) === "liveclass");
                    break;
                default:
                    adIs = undefined;
                    break;
            }
        if (adIs) {
            setAdvertisement(adIs.images);
        } else {
            setAdvertisement([]);
        }
      };
      handleAdvertisement();
   }, [activeTab, screenImages, schoolType]);

  const handleLiveSession = () => {
    const currentDateUTC = dayjs().utc().format();
    isLiveSessionNow({
      variables: {
        cId: selectedClassRoomId,
        currentDateTime: currentDateUTC
      }
    })
  }
    
  const tabComponentsVirtual = [
    <Subjects withoutHeader={true} tabName="LiveClass" handleLiveSession={handleLiveSession} adimage={advertisements} imageLoader={loader} />,
    <MyLibrary adimage={advertisements} imageLoader={loader} />,
  ];

    const tabcomponents = [
       <MyLibrary adimage={advertisements} imageLoader={loader}/>,
       <Subjects withoutHeader={true} tabName="Quiz" handleLiveSession={handleLiveSession} adimage={advertisements} imageLoader={loader}/>,
       <Subjects withoutHeader={true} tabName="Assignments" handleLiveSession={handleLiveSession} adimage={advertisements} imageLoader={loader}/>,
       <Subjects withoutHeader={true} tabName="Chats" handleLiveSession={handleLiveSession} adimage={advertisements} imageLoader={loader}/>,
       <Subjects withoutHeader={true} tabName="LiveClass" handleLiveSession={handleLiveSession} adimage={advertisements} imageLoader={loader}/>
      ];  

      // const tabsToRender = schoolType === VIRTUAL ? tabComponentsVirtual : tabcomponents;
      const tabsToRender = tabcomponents;


    //   const tabLabels = schoolType === VIRTUAL 
    // ? ["Live Class", "My Library"] 
    // : ["My Library", "Quiz", "Assignments", "Chats", "Live Class"];
          const tabLabels = ["My Library", "Quiz", "Assignments", "Chats", "Live Class"];

  useEffect(() => {
    if(selectedClassRoomId && !liveSessionInitializedRef.current){
      liveSessionInitializedRef.current = true;
      handleLiveSession();
    }
  },[selectedClassRoomId])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response: AxiosResponse<Advertisement[]> = await axios.get(
          `${katonCms}/class_room_advertisement`,
          {
            headers: {
              "X-Hash-Key": process.env.REACT_APP_KATON_SITE_API_KEY,
            },
          }
        );
        const advertisements = response.data;
        const role = localStorage.getItem("role") || "";

        const schoolAdminScreens: Record<string, string[]> = advertisements
          .filter((ad: Advertisement) =>
            ad.categories
              .map((category) => category.toLowerCase())
              .includes(role)
          )
          .reduce((acc: Record<string, string[]>, ad: Advertisement) => {
            const { Screen, Image } = ad;
            if (!acc[Screen]) {
              acc[Screen] = [];
            }
            acc[Screen].push(`${katonCms?.split("/wp-json")[0]}${Image}`);
            return acc;
          }, {});

        const result: ScreenImages[] = Object.keys(schoolAdminScreens).map(
          (screen: string) => ({
            screen,
            images: schoolAdminScreens[screen],
          })
        );
        setScreenImages(result)
      } catch (err) {
        console.log(err);
      }finally {
        setLoading(false); // Stop the loader
      }
    };

    fetchData();
  }, []);


  useEffect(()=>{
    setActiveTab(parseInt(selectedTabindex));
  },[selectedTabindex]);

  return (
    <div className='teacherStudentClassroomMain'>
      {getScreenDimensions()?.isMobileScreen ?
      <>
        <MobileScreenHeader
          profileImage={profileImage}
          role={role}
          studentName={StudentName}
          profile={profile}
        />
        <h3 className='mobiletabLabel'>{tabLabels[activeTab]}</h3>
        </>
        :
          <div className='tabsContainer'>
            <StyledTabs
                value={activeTab}
                onChange={handleChangeTab}
                // variant='fullWidth'
            >
              {tabLabels.map((label, index) => (
            <CustomTab key={index} label={label} />
          ))}
                {/* <CustomTab label={'My Library'}/>
                <CustomTab label={'Quiz'}/>
                <CustomTab label={'Assignments'}/>
                <CustomTab label={'Chats'}/>
                <CustomTab label={'Live Class'} />  */}
                {<img src={redDotImage} className={'redDotStyle'} alt='redDotImage' style={{visibility : isLive ? 'visible':'hidden'}}/>}
                {role === STUDENT_ROLE && <img src={redDotImage} className='redDotStyleForQuiz' alt='redDotImage' style={{visibility : (isquizActive) ? 'visible':'hidden'}}/>}
                {role === STUDENT_ROLE && 
                  <img 
                    src={redDotImage} 
                    className='redDotStyleForAssignment' 
                    alt='redDotImage' 
                    style={{visibility : (isAssignmentActive) ? 'visible':'hidden'}}
                  />
                }
                {role === STUDENT_ROLE && 
                  <img 
                    src={redDotImage} 
                    className={'redDotStyleForMylibary'} 
                    alt='redDotImage' 
                    style={{visibility : isMylibaryActive ? 'visible':'hidden'}}
                  />
                }
                {role === STUDENT_ROLE && <img src={redDotImage} className='redDotStyleForChat' alt='redDotImage' style={{visibility : (isChatActive) ? 'visible':'hidden'}}/>}
            </StyledTabs>
            {/* <span className='redDotStyle'></span> */}
            </div>
      }
            <div className='componentMainContainer'>
              {tabsToRender?.[activeTab] ? tabsToRender?.[activeTab] : tabsToRender?.[0]}
            </div>
    </div>
  )
}

export default TeacherStudentClassroom;
